import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { HolidaysComponent } from './holidays/holidays.component';
import { MomentModule } from 'ngx-moment';
import { HolidayEditComponent } from './holidays/holiday-edit/holiday-edit.component';
import { HolidayGroupsComponent } from './holiday-groups/holiday-groups.component';
import { HolidayGroupEditComponent } from './holiday-groups/holiday-group-edit/holiday-group-edit.component';
import { BillingComponent } from './billing.component';
import { SchedulesComponent } from './schedules/schedules.component';
import { ScheduleEditComponent } from './schedules/schedule-edit/schedule-edit.component';
import { ExportListComponent } from './export-list/export-list.component';
import { ArticlesComponent } from './articles/articles.component';
import { ArticleCreateComponent } from './articles/article-create/article-create.component';
import { WaitingTimesComponent } from './waiting-times/waiting-times.component';
import { WaitingTimeEditComponent } from './waiting-times/waiting-time-edit/waiting-time-edit.component';
import { PreBillingHistoryComponent } from './pre-billing/pre-billing-history/pre-billing-history.component';
import { PreBillingNewComponent } from './pre-billing/pre-billing-new/pre-billing-new.component';
import { PreBillingComponent } from './pre-billing/pre-billing.component';
import { CRMComponent } from './crm/crm.component';
import { CRMFilterFormComponent } from './crm/crm-filter-form/crm-filter-form.component';
import { CRMChartByMonthComponent } from './crm/crm-charts/crm-chart-by-month/crm-chart-by-month.component';
import { CRMChartByYearComponent } from './crm/crm-charts/crm-chart-by-year/crm-chart-by-year.component';
import { CRMChartsComponent } from './crm/crm-charts/crm-charts.component';
import { CRMTableByMonthComponent } from './crm/crm-table-by-month/crm-table-by-month.component';
import { CRMTotalCardComponent } from './crm/crm-total-card/crm-total-card.component';

@NgModule({
  declarations: [
    BillingComponent,
    HolidaysComponent,
    HolidayEditComponent,
    HolidayGroupsComponent,
    HolidayGroupEditComponent,
    SchedulesComponent,
    ScheduleEditComponent,
    ExportListComponent,
    ArticlesComponent,
    ArticleCreateComponent,
    WaitingTimesComponent,
    WaitingTimeEditComponent,
    PreBillingComponent,
    PreBillingHistoryComponent,
    PreBillingNewComponent,
    CRMComponent,
    CRMFilterFormComponent,
    CRMTotalCardComponent,
    CRMTableByMonthComponent,
    CRMChartsComponent,
    CRMChartByMonthComponent,
    CRMChartByYearComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    MomentModule
  ]
})
export class BillingModule { }
